import React, { FC } from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";

import {
  CsobHubWelcomeBanner,
  CsobHubQuestionnaires,
  CsobHubHelpCard,
  CsobHubDatasetChoiceModal,
  CsobHubInfoBanner,
  CsobHubTermsAndConditionsModal,
  CredacChangeModal,
} from "@components/main/csob/hub";
import { Grid } from "@components/base";
import ActionCards from "@components/main/csob/hub/ActionCards";
import { useGetCurrentCsobCompanyInfo } from "@api";
import { useUserStore } from "@store/user";
import { PageTitle } from "@components/common";

const CsobHubPage: FC = () => {
  const { t } = useTranslation();
  const { user } = useUserStore();
  const { currentCsobCompanyInfo } = useGetCurrentCsobCompanyInfo(user);

  return (
    <Box mb={6}>
      <PageTitle title={t("menu.csobHub")} />
      <Grid container spacing={3}>
        {currentCsobCompanyInfo?.credacCode && <CsobHubInfoBanner />}
        <CsobHubWelcomeBanner />
        {currentCsobCompanyInfo?.credacCode && (
          <>
            <Grid size={12}>
              <ActionCards />
            </Grid>
            <Grid size={12}>
              <CsobHubQuestionnaires />
            </Grid>
          </>
        )}
        <Grid size={{ md: 12 }}>
          <CsobHubHelpCard />
        </Grid>
      </Grid>
      {currentCsobCompanyInfo?.credacCode && <CsobHubDatasetChoiceModal />}
      <CsobHubTermsAndConditionsModal />
      <CredacChangeModal />
    </Box>
  );
};

export default CsobHubPage;
